<template>
  <div id="exportDataPackage">
    <ots-main-title></ots-main-title>
    <ots-refer
      :selectList="selectList"
      :requestForm="requestForm"
    ></ots-refer>
    <div class="mainCon">
      <el-button round type="primary" plain @click="exportExamPackage">导出考试数据包</el-button>
      <el-button round type="primary" plain @click="export_QAN_Package">导出管理机注册二维码与序列号</el-button>
      <el-button round type="primary" plain @click="exportAuthCode">导出授权码</el-button>
    </div>
  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { exportPlaceToPdfAPI, exportAuthCodeAPI } from "@/http/modules/computedRoomExam";
import { downloadPreGeneratedAnswerPaperAPI } from "@/http/modules/examSet/planClass";

export default {
  name: "exportDataPackage",
  data() {
    return {
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
      ],
      requestForm: {
        planId: '',
        placeId: '',
      }
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
    },
  },
  mounted() {
    this.getPlan();
  },
  methods: {
    async getPlan() {
      const { data: planData } = await getSelectPlanFn();
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },
    async getPlace(value) {
      const { data: placeData } = await getCurrentSelectPlace({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },

    // 考试包
    async exportExamPackage() {
      let params = {...this.requestForm}
      const {code, data} = await downloadPreGeneratedAnswerPaperAPI(params);
      if (code == 1) {
        window.open(data);
      }
    },

    // 二维码/序列号
    async export_QAN_Package() {
      const { code, data } = await exportPlaceToPdfAPI({planId: this.requestForm.planId});
      if (code == 1) {
        window.open(data);
      }
    },
      
    // 授权码
    async exportAuthCode() {
      let params = {...this.requestForm}
      const {code, data} = await exportAuthCodeAPI(params);
      if (code == 1) {
        window.open(data);
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>